import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Youtube, Music2 } from 'lucide-react';

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-pond text-offwhite">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 pt-20 md:pt-28 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-6">
            <p className="overline text-sky mb-4">Asana Fishing &amp; Ecological Resorts · Bulacan</p>
            <h3 className="editorial-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Come for the catch.
              <br />
              Stay for the feast.
              <br />
              <em className="italic font-light text-sky">Return for the peace.</em>
            </h3>
          </div>

          <div className="md:col-span-2">
            <p className="overline text-sky/80 mb-4">Visit</p>
            <ul className="space-y-2 text-offwhite/85 text-sm">
              <li><Link to="/#experiences" className="hover:text-sky">Experiences</Link></li>
              <li><Link to="/#offerings" className="hover:text-sky">Fishing</Link></li>
              <li><Link to="/#rates" className="hover:text-sky">Rates</Link></li>
              <li><Link to="/getting-here" className="hover:text-sky">Getting Here</Link></li>
              <li><Link to="/#book" className="hover:text-sky">Book a Visit</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="overline text-sky/80 mb-4">About</p>
            <ul className="space-y-2 text-offwhite/85 text-sm">
              <li><a href="#story" className="hover:text-sky">Our Story</a></li>
              <li><a href="#ecology" className="hover:text-sky">Ecology</a></li>
              <li><a href="#gallery" className="hover:text-sky">Gallery</a></li>
              <li><a href="#faq" className="hover:text-sky">FAQ</a></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="overline text-sky/80 mb-4">Connect</p>
            <ul className="space-y-2 text-offwhite/85 text-sm">
              <li><a href="#contact" className="hover:text-sky">Contact</a></li>
              <li><a href="mailto:hellopo@asanafishingresort.com" className="hover:text-sky break-all">Email us</a></li>
              <li><a href="tel:+639170000000" className="hover:text-sky">Call us</a></li>
            </ul>
            <div className="flex gap-2 mt-5 flex-wrap">
              <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram" className="w-9 h-9 rounded-full border border-offwhite/40 flex items-center justify-center hover:bg-offwhite hover:text-pond transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook" className="w-9 h-9 rounded-full border border-offwhite/40 flex items-center justify-center hover:bg-offwhite hover:text-pond transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube" className="w-9 h-9 rounded-full border border-offwhite/40 flex items-center justify-center hover:bg-offwhite hover:text-pond transition-colors">
                <Youtube className="w-4 h-4" />
              </a>
              <a href="https://tiktok.com" target="_blank" rel="noreferrer" aria-label="TikTok" className="w-9 h-9 rounded-full border border-offwhite/40 flex items-center justify-center hover:bg-offwhite hover:text-pond transition-colors">
                <Music2 className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-offwhite/15 pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-offwhite/60">
          <p>© {new Date().getFullYear()} Asana Fishing and Ecological Resorts. All rights reserved.</p>
          <p>
            Sitio Asana, Ubihan, City of Meycauayan, 3020 Bulacan · Phase 1 in progress.
          </p>
        </div>
      </div>
    </footer>
  );
}
